// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuItem_container__1-rvu","label":"MenuItem_label__1U8tY"};